export default {
    /**
     * Datos añadidos a data por el mixin:
     * -  crsIndicators: array con tipos de indicadores CRS
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            crsIndicators: []
        };
    },
    methods: {
        /**
         * Load Indicators types
         */
        loadCrsIndicatorsOptions() {
            const indicatorsTypes = this.$t(`interveners.crs.indicators`);
            this.crsIndicators = Object.entries(indicatorsTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de indicadores en la variable
     * `this.crsIndicators`
     */
    beforeMount() {
        this.loadCrsIndicatorsOptions();
    }
};

